.filtersWall {
  position: relative;
  font-size: var(--cxy-fontSize-xs);
}

.fadedContent {
  pointer-events: none;
  opacity: 0.15;
}

.contentWrapper {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.textWrapper {
  text-align: center;
}
.textWrapper > span {
  line-height: var(--cxy-lineHeight-xs);
  font-size: var(--cxy-fontSize-s);
  vertical-align: middle;
  padding-bottom: var(--cxy-spacing-0);
}

.ghostButton {
  color: var(--cxy-color-brand);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
}

.svg {
  color: var(--cxy-color-brand);
  height: var(--cxy-icon-size-m);
  width: var(--cxy-icon-size-m);
  margin-bottom: var(--cxy-spacing-2);
}
.svg path {
  stroke: var(--cxy-color-brand);
}
